<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <form-admin-action-document :id="id" />
        </b-card>
    </div>
</template>

<script>
    import FormAdminActionDocument from '~/components/forms/admin/action-document/form'

    export default {
        name: 'edit',
        props: {
            id: {
                required: true,
            },
        },
        components: {
            'form-admin-action-document': FormAdminActionDocument,
        },
    }
</script>

<style lang="scss" scoped>
</style>